<div
  class="background {{ singleColumn() ? 'single-column-content' : 'two-columns-content' }}"
  [style.background-image]="'url(' + backgroundImage() + ')'"
  [style.--left-column-width]="leftColumnWidth()"
  [style.--right-column-width]="rightColumnWidth()">
  @if (singleColumn()) {
    <ng-content />
  } @else {
    <div class="left-section">
      <ng-content select="[leftColumn]" />
    </div>
    <div class="right-section">
      <ng-content select="[rightColumn]" />
    </div>
  }
</div>
